import SCHCTemplatesManageDataRules from './SCHCTemplatesManageDataRules';

export default SCHCTemplatesManageDataRules;
